import pakTani from 'assets/icons/Pak-Tani.png'
import AmountInput from 'components/AmountInput'
import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import useAutoFetchPublicVersion from 'hooks/useAutoFetchPublicVersion'
import moment from 'moment-timezone'
import { useSnackbar } from 'notistack'
import { useEffect, useRef, useState } from 'react'
import { ArrowLeft, Calendar, Check, Edit2, Trash2 } from 'react-feather'
import Flatpickr from 'react-flatpickr'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import SelectInputWithTestId from 'components/PMBSelect/SelectInputWithTestId'
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  Spinner,
} from 'reactstrap'
import { HISTORY_ARUS_KAS } from 'utils/pathUrl'
import {
  setIsModalOpenAddAddressBook,
  setSearchAddressBook,
} from '../address-book/addressBookSlice'
import InputAddressBook from '../address-book/InputAddressBook'
import ModalAddContact from '../address-book/ModalAddContact'
import { useLazyCheckPhoneNumberPayableQuery } from '../payable-notes/payableNotesApiSlice'
import { getComodities } from './cashFlowAction'
import {
  useGetCategoriesCashFlowQuery,
  useGetCategoriesCashFlowPersonalQuery,
  usePostCashFlowMutation,
  usePostCashFlowPersonalMutation,
} from './cashFlowApiSlice'
import { toggleModalCategory, toggleModalDelete } from './cashFlowSlice'
import ModalCategory from './ModalCategory'
import ModalDelete from './ModalDelete'
import ProfilePic from 'components/PMBProfilePic'

const FormCashFlow = () => {
  const { enqueueSnackbar } = useSnackbar()
  const autoFetchPublicVersion = useAutoFetchPublicVersion()
  const intl = useIntl()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { state: dataState } = useLocation()

  const d = new Date()
  const today = new Date().toISOString().split('T')[0]

  const [payload, setPayload] = useState({
    unit: { value: 'Kg', label: 'Kg' },
    selectedDate: today,
  })
  const [totalAmount, setTotalAmount] = useState(null)
  const [quantity, setQuantity] = useState(null)
  const [price, setPrice] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [category, setCategory] = useState(null)
  const [isKomoditas, setIsKomoditas] = useState(false)
  const [dataUser, setDataUser] = useState(null)
  const addressBookRef = useRef(null)

  const toggleOpenCloseAddContact = () => {
    dispatch(setIsModalOpenAddAddressBook(!isModalOpenAddAddressBook))
  }

  const {
    comodities: listComodities,
    isOpenModalDelete,
    isOpenModalCategory,
  } = useSelector((s) => s.cashflow)
  const { ownerData, profile } = useSelector((s) => s.dashboard)
  const { data } = useSelector((state) => state.publicVersion)
  const { isModalOpenAddAddressBook } = useSelector((e) => e.addressBook)

  const [checkPhoneNumber, res] = useLazyCheckPhoneNumberPayableQuery()
  const [postCashFlow, result] = usePostCashFlowMutation()
  const [postCashFlowPersonal, resultPersonal] =
    usePostCashFlowPersonalMutation()
  const isPersonal = dataState?.isPersonal

  const { data: dataCategory, isLoading } = useGetCategoriesCashFlowQuery(
    {
      type: dataState?.income ? 'income' : 'expense',
      active: 1,
      userId: ownerData?.userId,
    },
    { skip: !ownerData || isPersonal },
  )

  const { data: dataCategoryPersonal, isLoading: isLoadingPersonal } =
    useGetCategoriesCashFlowPersonalQuery(
      {
        type: dataState?.income ? 'income' : 'expense',
        active: 1,
        userId: profile?.userId,
      },
      { skip: !profile || !isPersonal },
    )

  const activeCategoryData = isPersonal ? dataCategoryPersonal : dataCategory
  const activeCategoryLoading = isPersonal ? isLoadingPersonal : isLoading

  const handleCheckPhoneNumber = async (phoneOrEmail) => {
    try {
      if (phoneOrEmail) {
        const res = await checkPhoneNumber({
          search: phoneOrEmail,
          type: dataState?.income ? 'SELL' : 'BUY',
        })
        if (res?.error || res?.isError) {
          enqueueSnackbar(
            res?.error?.data?.message ??
            res?.error?.message ??
            res?.error?.data?.meta?.message ??
            'Terjadi Kendala',
            {
              variant: 'error',
            },
          )
          setDataUser(null)
        } else {
          setDataUser(res?.data)
          setPayload((prev) => {
            return {
              ...prev,
              name: res?.data?.fullName,
            }
          })
        }
      }
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message ??
        error?.message ??
        error?.data?.meta?.message ??
        'Terjadi Kendala',
        {
          variant: 'error',
        },
      )
    }
  }

  const handleSelectedContact = (contact) => {
    handleCheckPhoneNumber(
      contact?.relationPhoneNumber ?? contact?.relationEmail,
    )

    if (Object.keys(contact).length !== 0) {
      setDataUser(contact)
      setPayload((prev) => ({
        ...prev,
        picname: contact?.relationName ?? '',
      }))
    } else {
      setDataUser(null)
    }
  }

  const handleSubmit = async () => {
    try {
      let body = {
        amount:
          payload?.category?.label?.toLowerCase() === 'penjualan' ||
            payload?.category?.label?.toLowerCase() === 'pembelian'
            ? payload?.totalPrice
            : Number(
              totalAmount
                ?.replace?.(/\./g, '')
                ?.replace?.(/,/g, '.')
                ?.slice?.(0, 15),
            ),
        label:
          payload?.category?.label?.toLowerCase() === 'penjualan' && isKomoditas
            ? `Penjualan ${payload?.comodity?.label}`
            : payload?.category?.label?.toLowerCase() === 'pembelian' &&
              isKomoditas
              ? `Pembelian ${payload?.comodity?.label}`
              : payload?.category?.label?.toLowerCase() === 'pembelian' &&
                !isKomoditas
                ? `Pembelian ${payload?.label}`
                : payload?.category?.label?.toLowerCase() === 'penjualan' &&
                  !isKomoditas
                  ? `Penjualan ${payload?.label}`
                  : payload?.category?.label,
        notes: payload?.notes,
        picname: payload?.picname,
        offlineCustomTypeId: payload?.category?.id,
        incomeorexpense: dataState?.income ? 'income' : 'expense',
        type: payload?.category?.label,
        ...((payload?.category?.label?.toLowerCase() === 'penjualan' ||
          payload?.category?.label?.toLowerCase() === 'pembelian') && {
          items: [
            {
              ...(isKomoditas && {
                name: payload?.comodity?.label,
                itemId: payload?.comodity?.id,
              }),
              ...(!isKomoditas && {
                item: payload?.label,
              }),
              qty: `${quantity} ${payload?.unit?.value}`,
              unit: payload?.unit?.value,
            },
          ],
        }),
        date: payload?.selectedDate,
        ...(dataState?.isEdit && {
          offlineID: dataState?.offlineID,
        }),
      }

      const resp = await (
        isPersonal ? postCashFlowPersonal(body) : postCashFlow(body)
      ).unwrap()

      if (!resp?.data?.error) {
        // dispatch(toggleBanner())
        if (dataState?.income) {
          navigate(
            isPersonal
              ? `${HISTORY_ARUS_KAS}? personal=true`
              : HISTORY_ARUS_KAS,
            { state: { income: true } },
          )
        } else {
          navigate(
            isPersonal ? `${HISTORY_ARUS_KAS}?personal=true` : HISTORY_ARUS_KAS,
            { state: { expense: true } },
          )
        }

        enqueueSnackbar(
          `${dataState?.income ? 'Pemasukan' : 'Pengeluaran'} baru berhasil dicatat.`,
          { variant: 'success' },
        )
      } else {
        throw resp
      }
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message ??
        error?.message ??
        error?.data?.meta?.message ??
        'Terjadi Kendala',
        {
          variant: 'error',
        },
      )
    }
  }

  const handleEditCategory = () => {
    if (!isEdit) {
      setIsEdit(true)
      setPayload((prev) => {
        return {
          ...prev,
          category: null,
        }
      })
    } else {
      setIsEdit(false)
    }
  }

  useEffect(() => {
    if (quantity || price) {
      setPayload((prev) => {
        return {
          ...prev,
          totalPrice:
            quantity
              ?.replace?.(/\./g, '')
              ?.replace?.(/,/g, '.')
              ?.slice?.(0, 15) *
            price?.replace?.(/\./g, '')?.replace?.(/,/g, '.')?.slice?.(0, 15),
        }
      })
    }
  }, [quantity, price])

  useEffect(() => {
    if (
      (payload?.category?.label?.toLowerCase() === 'penjualan' ||
        payload?.category?.label?.toLowerCase() === 'pembelian') &&
      data?.unitArray?.length < 1
    ) {
      autoFetchPublicVersion()
    }
    if (isKomoditas && listComodities?.length < 1) {
      dispatch(getComodities())
    }
  }, [payload?.category, isKomoditas])

  useEffect(() => {
    if (dataState?.isEdit && activeCategoryData) {
      setPayload({
        picname: dataState?.extradata?.picname,
        selectedDate: dataState?.createddate,
        notes: dataState?.notes,
        totalPrice: dataState?.amount,
        label:
          dataState?.extradata?.items?.[0]?.item ??
          dataState?.extradata?.label?.split(' ')?.slice(1)?.join(' ') ??
          '',
        category: activeCategoryData?.find(
          (e) => e?.label === dataState?.extradata?.type,
        ),
        unit: data?.unitArray.find(
          (e) =>
            e?.label ===
            dataState?.extradata?.items?.[0]?.qty.split(' ').slice(1).join(' '),
        ),
        comodity: listComodities?.find(
          (e) => e?.label === dataState?.extradata?.items?.[0]?.name,
        ),
      })
      setTotalAmount(dataState?.amount ?? payload?.totalPrice)

      setPrice(
        dataState?.amount /
        dataState?.extradata?.items?.[0]?.qty.match(/\d+/)?.[0],
      )
      setIsKomoditas(dataState?.extradata?.items?.[0]?.name ? true : false)
      setQuantity(dataState?.extradata?.items?.[0]?.qty.match(/\d+/)?.[0])
    }
  }, [dataState, activeCategoryData])

  useEffect(() => {
    if (payload?.totalPrice && dataState?.isEdit) {
      setTotalAmount(payload?.totalPrice)
    }
  }, [payload?.totalPrice, dataState])

  return (
    <>
      <ModalDelete
        isOpen={isOpenModalDelete}
        toggle={() => dispatch(toggleModalDelete())}
        row={category}
        isCategory
        isIncome={dataState?.income ?? false}
        isPersonal={isPersonal}
      />
      <ModalCategory
        isOpen={isOpenModalCategory}
        toggle={() => dispatch(toggleModalCategory())}
        row={category}
        isIncome={dataState?.income ?? false}
        isPersonal={isPersonal}
      />
      <ModalAddContact
        isOpen={isModalOpenAddAddressBook}
        toggle={toggleOpenCloseAddContact}
        isOutsideAddressBook
      />

      <Container className="custom-container d-flex flex-column gap-3 py-3">
        <div className="d-flex align-items-start gap-2 pt-3">
          <BreadCrumbs
            breadCrumbActive={'Catat Arus Kas'}
            breadCrumbParentLink={HISTORY_ARUS_KAS}
            breadCrumbParent={'Riwayat Arus Kas'}
          />
        </div>
        <Card className="border-0 shadow-sm">
          <CardBody>
            <h5 className="fw-semibold">
              <ArrowLeft
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(HISTORY_ARUS_KAS)}
              />{' '}
              Catat {dataState?.income ? 'Pemasukan' : 'Pengeluaran'}
            </h5>

            <Label className="fw-500 d-flex justify-content-between mt-4">
              <span>
                Kategori <span className="text-danger">*</span>
              </span>
              <span
                onClick={() => handleEditCategory()}
                className={isEdit ? 'text-success' : 'text-primary'}
                style={{ cursor: 'pointer' }}
              >
                {isEdit ? 'Selesai' : 'Atur Kategori'}
              </span>
            </Label>
            {activeCategoryLoading ? (
              <div className="flex-centered">
                {' '}
                <Spinner />{' '}
              </div>
            ) : (
              activeCategoryData?.map((e, i) => {
                return (
                  <div
                    key={i}
                    className="py-2"
                    onClick={() => {
                      if (!isEdit) {
                        setPayload((prev) => {
                          return {
                            ...prev,
                            category: e,
                          }
                        })
                      }
                    }}
                  >
                    <div
                      style={{
                        backgroundColor:
                          payload?.category?.id === e?.id ? '#ECFAFF' : '',
                      }}
                      className={`border rounded p-3 d-flex ${isEdit ? 'justify-content-between' : 'gap-2'} ${payload?.category?.id === e?.id ? 'border-primary' : ''}`}
                    >
                      {isEdit ? (
                        <></>
                      ) : (
                        <Input
                          type="radio"
                          id="category"
                          name="category"
                          value={payload?.category?.id ?? ''}
                          onChange={() => {
                            if (!isEdit) {
                              setPayload((prev) => {
                                return {
                                  ...prev,
                                  category: e,
                                }
                              })
                            }
                          }}
                          checked={payload?.category?.id === e?.id}
                          autoComplete="off"
                        />
                      )}
                      {e?.label}
                      {isEdit ? (
                        <div className="d-flex gap-3">
                          <Edit2
                            onClick={() => {
                              setCategory(e)
                              dispatch(toggleModalCategory())
                            }}
                            style={{ cursor: 'pointer' }}
                            size={16}
                          />
                          <Trash2
                            onClick={() => {
                              setCategory(e)
                              dispatch(toggleModalDelete())
                            }}
                            style={{ cursor: 'pointer' }}
                            size={16}
                            className="text-danger"
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                )
              })
            )}

            <hr></hr>
            {isEdit ? (
              <CustomButton
                onClick={() => {
                  setCategory(null)
                  dispatch(toggleModalCategory())
                }}
                outline
                color="primary"
              >
                + Tambah Kategori
              </CustomButton>
            ) : (
              <></>
            )}
          </CardBody>
        </Card>

        <Card className="border-0 shadow-sm">
          <CardBody>
            <FormGroup>
              <div className="mb-3">
                <InputAddressBook
                  title={
                    payload?.category?.label?.toLowerCase() === 'penjualan' ||
                      payload?.category?.label?.toLowerCase() === 'pembelian'
                      ? dataState?.income
                        ? 'Nama pembeli'
                        : 'Nama penjual'
                      : dataState?.income
                        ? 'Pemasukan dari'
                        : 'Pengeluaran ke'
                  }
                  onSelectContact={handleSelectedContact}
                  fieldName="picname"
                  onClickAdd={(localSearch) =>
                    dispatch(setSearchAddressBook(localSearch))
                  }
                  innerRef={addressBookRef}
                  useCombinedContacts
                />
              </div>
            </FormGroup>
            {dataUser && (
              <FormGroup>
                <div className="flex-centered justify-content-between border p-2 rounded bg-success-25 border-success">
                  <div className="flex-centered gap-2">
                    <ProfilePic
                      imgSrc={dataUser?.profileImg}
                      altText={dataUser?.fullName ?? dataUser?.relationName}
                      name={dataUser?.fullName ?? dataUser?.relationName}
                      avatarSeed={
                        dataUser?.userId ??
                        dataUser?.relationUserId ??
                        dataUser?.relationEmailUserId
                      }
                      width={36}
                      height={35}
                    />
                    <span className="text-sm fw-semibold">
                      {dataUser?.fullName ?? dataUser?.relationName}
                    </span>
                  </div>
                  <>
                    <Check className="text-success" />
                  </>
                  <Badge size="sm" disabled className={'badge-warning'}></Badge>
                </div>
              </FormGroup>
            )}
            <FormGroup>
              <Label className="fw-500">Tanggal</Label>
              <div className="d-flex align-items-center justify-content-center border rounded">
                <Calendar size={17} className="ms-3" />
                <Flatpickr
                  value={[
                    payload.selectedDate ? new Date(payload?.selectedDate) : '',
                  ]}
                  options={{
                    dateFormat: 'd-M-Y',
                    defaultDate: new Date(),
                    onClose: (selectedDate, dateStr, instance) => {
                      setPayload((prev) => ({
                        ...prev,
                        selectedDate: moment(selectedDate[0])
                          .local()
                          .format('YYYY-MM-DD'),
                      }))
                    },
                  }}
                  className="form-control flat-picker bg-transparent border-0 shadow-none"
                />
              </div>
            </FormGroup>

            {payload?.category?.label?.toLowerCase() === 'penjualan' ||
              payload?.category?.label?.toLowerCase() === 'pembelian' ? (
              <>
                <hr></hr>
                <FormGroup>
                  <Input
                    id="isKomoditas"
                    type="checkbox"
                    name="isKomoditas"
                    value={isKomoditas ?? ''}
                    checked={isKomoditas}
                    onChange={(e) => {
                      setIsKomoditas(!isKomoditas)
                    }}
                  />{' '}
                  {dataState?.income ? 'Penjualan' : 'Pembelian'} barang
                </FormGroup>

                {isKomoditas ? (
                  <FormGroup>
                    <Label className="fw-500">Barang</Label>
                    <Select
                      name="comodity"
                      placeholder="Pilih barang"
                      options={listComodities}
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          comodity: e,
                        }))
                      }}
                      value={payload?.comodity ?? ''}
                      components={{ Input: SelectInputWithTestId }}
                      data-testid="cashflow-form-comodity-select"
                    />
                  </FormGroup>
                ) : (
                  <FormGroup>
                    <Label className="fw-500">
                      Barang yang {dataState?.income ? 'dijual' : 'dibeli'}
                    </Label>
                    <Input
                      name="label"
                      onChange={(e) => {
                        setPayload((prev) => ({
                          ...prev,
                          [e.target.name]: e.target?.value,
                        }))
                      }}
                      value={payload?.label}
                      placeholder="Masukkan nama barang"
                    />
                  </FormGroup>
                )}

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="fw-500">Jumlah</Label>
                      <AmountInput
                        name="quantity"
                        value={quantity ?? ''}
                        cb={(res) => {
                          setQuantity(res)
                        }}
                        placeholder="0"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="fw-500">Satuan</Label>
                      <Select
                        options={data?.unitArray}
                        name="unit"
                        onChange={(e) => {
                          setPayload((prev) => ({
                            ...prev,
                            unit: e,
                          }))
                        }}
                        placeholder="Pilih satuan"
                        value={payload?.unit ?? ''}
                        components={{ Input: SelectInputWithTestId }}
                        data-testid="cashflow-form-unit-select"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="fw-500">Harga per satuan</Label>
                      <InputGroup>
                        <InputGroupText className="bg-transparent">
                          Rp
                        </InputGroupText>
                        <AmountInput
                          name="price"
                          value={price ?? ''}
                          cb={(res) => {
                            setPrice(res)
                          }}
                          placeholder="0"
                          dotOnly
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="fw-500">Harga Total</Label>
                      <InputGroup>
                        <InputGroupText className="bg-transparent">
                          Rp
                        </InputGroupText>
                        <Input
                          disabled={true}
                          type="text"
                          value={intl.formatNumber(
                            isNaN(payload?.totalPrice)
                              ? 0
                              : (payload?.totalPrice ?? 0),
                            {
                              useGrouping: 'always',
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 3,
                            },
                          )}
                          onChange={() => { }}
                          name="totalPrice"
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
            {payload?.category?.label?.toLowerCase() !== 'penjualan' &&
              payload?.category?.label?.toLowerCase() !== 'pembelian' ? (
              <FormGroup>
                <Label className="fw-500">
                  Jumlah uang {dataState?.income ? 'masuk' : 'keluar'}
                </Label>

                <InputGroup>
                  <InputGroupText className="bg-transparent">Rp</InputGroupText>
                  <AmountInput
                    name="totalAmount"
                    value={totalAmount ?? ''}
                    cb={(res) => {
                      setTotalAmount(res)
                    }}
                    placeholder="0"
                  />
                </InputGroup>
              </FormGroup>
            ) : (
              <></>
            )}
            <FormGroup>
              <Label className="fw-500">Catatan (opsional)</Label>
              <Input
                type="textarea"
                style={{ minHeight: '128px' }}
                name="notes"
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    [e.target.name]: e.target?.value,
                  }))
                }}
                value={payload?.notes}
                placeholder="Tambah catatan jika ada..."
              />
            </FormGroup>

            <div className="d-flex gap-3">
              <Button
                onClick={() => {
                  if (dataState?.income) {
                    navigate(HISTORY_ARUS_KAS, { state: { income: true } })
                  } else {
                    navigate(HISTORY_ARUS_KAS, { state: { expense: true } })
                  }
                }}
                outline
                className="btn-cancel"
                block
              >
                Batal
              </Button>
              <Button
                disabled={
                  payload?.category?.label?.toLowerCase() === 'penjualan' ||
                    payload?.category?.label?.toLowerCase() === 'pembelian'
                    ? !payload ||
                    !payload?.category ||
                    !payload?.picname ||
                    !payload?.totalPrice ||
                    !price ||
                    !quantity ||
                    result?.isLoading ||
                    resultPersonal?.isLoading
                    : !payload ||
                    !payload?.category ||
                    !payload?.picname ||
                    !totalAmount ||
                    result?.isLoading ||
                    resultPersonal?.isLoading
                }
                onClick={() => handleSubmit()}
                color="primary"
                block
              >
                Simpan
              </Button>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  )
}

export default FormCashFlow
